import { makeRequest, Methods } from "./request";
import { routes_api } from "../config/api";
import { api_url, default_api_token, front_url, tokenId } from "../config/constant";
import { getItem } from "../utils/storage";

// export const generateQrCode = async () => {
//   const id = getItem(tokenId)
//   const url = api_url+routes_api.qrcode.generate+id;
//   return await makeRequest(url, Methods.GET, null, {'Authorization': default_api_token});
// }

export function generateQrCode() {
  const id = getItem(tokenId)
  const associateUrl = `${front_url}/associate_screen/${id}`

  const url = `${api_url}${routes_api.qrcode.generate}${associateUrl}`;
  return makeRequest(url, Methods.GET, null, { 'Authorization': default_api_token });
}
